'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONSENT_TO_PROCESS = exports.CONSENT_TO_PROCESS = 'CONSENT_TO_PROCESS';
var CONSENT_TO_PROCESS_SUCCEEDED = exports.CONSENT_TO_PROCESS_SUCCEEDED = 'CONSENT_TO_PROCESS_SUCCEEDED';
var CONSENT_TO_PROCESS_FAILED = exports.CONSENT_TO_PROCESS_FAILED = 'CONSENT_TO_PROCESS_FAILED';

var CONSENT_TO_COMMUNICATE = exports.CONSENT_TO_COMMUNICATE = 'CONSENT_TO_COMMUNICATE';
var CONSENT_TO_COMMUNICATE_SUCCEEDED = exports.CONSENT_TO_COMMUNICATE_SUCCEEDED = 'CONSENT_TO_COMMUNICATE_SUCCEEDED';
var CONSENT_TO_COMMUNICATE_FAILED = exports.CONSENT_TO_COMMUNICATE_FAILED = 'CONSENT_TO_COMMUNICATE_FAILED';


//////////////////
// WEBPACK FOOTER
// ./js/gdpr/constants/ActionTypes.js
// module id = 279
// module chunks = 2 3